
<template>
  <div>
    <div class="policy_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <p class="mobitxt">ENGLISH TEXT</p>
          <p class="mobitxt">General conditions</p>
          <p class="mobitxt">Last modified: 13/08/2021</p>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">1. Applicability</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              The terms and conditions set out below (General Terms and
              Conditions) apply to the English version of the one-time paid
              service Miximo Premium (Puretech Global Sdn Bhd and / or the
              Service) offered online via the Internet from Puretech Global Sdn
              Bhd (hereinafter referred to as Puretech Global Sdn Bhd). The end
              user requires the Miximo service from Puretech Global Sdn Bhd.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">2. General</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Miximo provides the best sexy wallpapers and videos exclusively
              for your mobile.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">
              3. Confirmation / Registration
            </h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              To access Miximo, the End User must enter their mobile phone
              number and / or certain other data and / or information through a
              promotional website (Landing Page) operated by Puretech Global Sdn
              Bhd. Then the End User will receive an SMS on his mobile device,
              with a Personal Identification Number (PIN code), or a so-called
              offer message with information about the service. By entering the
              received PIN code on the landing page and / or sending a
              confirmation message and / or using the service, the End User
              acknowledges and confirms that he has read the General Terms and
              Conditions, is an authorized mobile phone account holder or has
              the consent of the telephone account payer to use this service.
              The end user will receive a confirmation SMS message about the
              successful activation of the Miximo service, the method, frequency
              and costs of taking over the Service, as well as the exact details
              of the logout.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">4. Costs and Fees</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Miximo is a paid service that costs 3 SMS x 1.60 EUR / week The
              fee will be charged to a mobile phone account or a prepaid mobile
              number. The method of charging is Premium MT SMS sent to the End
              User based on his request for the Miximo service. This message
              will include your Miximo login. Fees are collected according to
              Mobile Network Operators. Fees are written off against the End
              User's account by the Operator; in the case of a pre-subscription
              SIM, the fees are deducted from the End User's credit. The End
              User hereby expressly grants his or her authorization to charge,
              and undertakes to pay in full for the fees incurred as a result of
              subscribing to and / or using the Miximo Service. If you are not
              the person responsible for paying your mobile bill, please obtain
              permission from your mobile payer before signing in and / or using
              Miximo. By signing and / or participating in the Service, Puretech
              Global Sdn Bhd assumes that the End User has obtained the
              necessary permission, consent or approval from the mobile account
              payer, guardian or parents. All SMS messages sent by the End User
              will be charged by the End User's mobile operator at a standard
              tariff. These rates may vary by operator. Please contact your GSM
              operator for more information on charges.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">5. Help And Support</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Customer service is available on working days from 09:00 to 17:00
              Contact: +421 313215999 or miximo.{{
                country_Mix
              }}@silverlines.info
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">6. Intellectual Property</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              You may use the Service for your personal, non-commercial use. The
              term Miximo and all other trademarks, service marks and / or trade
              names used by Miximo on the Service from time to time (Trademarks)
              are trademarks, service marks and / or trade names of Puretech
              Global Sdn Bhd or one of its companies in the group or its
              licensors, and these entities reserve all rights to the
              Trademarks. In addition, other content of the Service, including,
              but not limited to, Games, images, pictures, graphics,
              photographs, animations, videos, music, sound and text belongs to
              Miximo, or one of its companies and / or licensed groups, and is
              protected by copyright and / or other intellectual property
              rights. You acknowledge that, through your use of the Service, you
              will not acquire any trademark rights or Content of the Service
              other than as set forth in this Agreement. In particular, under no
              circumstances may you copy any Content of the Service (including,
              without limitation, trivia questions, answers, or games), or use
              data mining, robots, screen scratches, or similar data collection
              and extraction tools on the Service. Liability Use of the Miximo
              and / or the Miximo website is at the end user's own risk. The end
              user must provide a compatible mobile phone, hardware, or other
              equipment and software, and ensure that they are operational and
              suitable for Miximo services. Miximo cannot guarantee that the
              Miximo services meet the requirements of the end user and that the
              download, receipt and / or viewing of the Miximo services will be
              uninterrupted or error free. If at any time the End User is unable
              to use the Puretech Global Sdn Bhd service without interruption,
              this in no way leads to the right to a reduction in fees for
              Miximo services, to any right to a refund of prepaid payments. Any
              use of the Miximo Services is at the end user's sole discretion
              and risk, and that for no, but not limited to, infections or
              contaminations, or loss of data, or damage (s) to end users'
              hardware and / or software resulting from access to the Website ,
              or use of the Miximo Services, or downloaded Miximo Services,
              including the hardware and software required to connect to the
              Miximo Services. It is the responsibility of end-users to take the
              necessary measures to prevent possible damage to this species. In
              the event that Miximo is obliged for any reason to compensate the
              end user for direct or consequential damages of any kind, such
              compensation may in no case exceed the value of the invoice for
              Miximo services paid by the end user for the alleged damages. The
              content of the Website has been compiled with the greatest care.
              However, Miximo cannot provide any guarantee as to the nature,
              accuracy or content of this information. Miximo is not responsible
              for any errors, omissions, inaccuracies, misunderstandings,
              delays, or illegible orders, or notices based on the use of the
              Internet or the relevant information point. Final Provisions Any
              disputes concerning the fulfillment of these Business Conditions
              will be resolved by the competent general courts. Puretech Global
              Sdn Bhd reserves the right to change these terms from time to
              time. Changes will be announced to end users by posting on the
              Miximo portal.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_Mix", "country_Mix"]),
};
</script>
<style>
.mobiFaq ul {
  list-style: inherit !important;
  padding-left: 30px !important;
}
.mobitxt a {
  display: inline !important;
  color: black !important;
}
.mobitxt a:hover {
  color: #007bff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/miximo/TermsEnglish.vue